/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PatchAnnotationPathParams = NonNullable<operations['patchAnnotation']['parameters']['path']>;

export type PatchAnnotationRequestBody = OperationRequestBodyContent<operations['patchAnnotation']>;

export interface Input extends PatchAnnotationPathParams {
  apiVersion?: string;
  body: PatchAnnotationRequestBody;
}

export async function patchAnnotation(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().PATCH('/internal/projects/{projKey}/environments/{envKey}/annotations/{traceId}/spans/{spanId}', {
    params: { path },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
